<script setup>
import { RouterView } from 'vue-router'
</script>

<template>
  <!-- 路由出口 -->
  <RouterView />
</template>

<style>
/* 全局样式 */
</style>